import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mapToName'
})
export class MapToNamePipe implements PipeTransform {

  transform(items: any[]): any[] {
    return items.map(i => {
      i['name'] = i.first_name + ' ' + i.last_name;
      return i;
    });
  }

}
